/*
 * What Claude, ChatGPT and Zapier can do in Tadpole, in plain words,
 * grouped from the backend's own lists. Paths are in the backend repo.
 * Nothing serves these to the app yet, so they are kept here; change them
 * with the code they come from. Claude and ChatGPT reach the same MCP
 * tools, so they share one pair of lists. The address and client ID to
 * enter, and Zapier's page, come from the backend with each app's status
 * (Automations/crud/apps.py).
 */

/** The MCP server's read tools (READ annotations), for Claude and ChatGPT. */
export const MCP_READS = [
  // read_tools.py:1498-1510: list_my_organizations, search_people, get_person
  "People",
  // read_tools.py list_meetings; money_tools.py:626-630 get_meeting;
  // org_tools.py:656-662 find_open_times, get_tutor_availability
  "Meetings, open times and tutor availability",
  // read_tools.py list_tasks
  "Tasks",
  // inbox_tools.py:514-517: list_messages, daily_briefing
  "Messages and the daily briefing",
  // read_tools.py list_balances; money_tools.py list_transactions,
  // get_report; reporting_tools.py:47-50
  "Balances, transactions and reports",
  // read_tools.py: list_crm_fields, crm_search, list_crm_boards,
  // get_crm_column_people
  "The CRM",
  // org_tools.py get_forms, get_message_templates
  "Forms and message templates",
  // automation_tools.py:350-355: get_automations, get_automation_choices,
  // get_automation_activity
  "Automations, their Activity and cards",
  // automation_tools.py get_connected_apps
  "Connected apps",
  // org_tools.py get_org_settings; read_tools.py list_subjects_and_places
  "Organization settings, subjects and places",
];

/** The MCP server's change tools: every one previews first (_confirmed). */
export const MCP_CHANGES = [
  // action_tools.py:628-644
  "Send messages, forms and templates",
  "Book, change and cancel meetings",
  "Set tutors' weekly availability",
  "Create and change tasks",
  "Invite, change and archive people",
  "Add notes and ask for a card or bank",
  "Move people to a CRM column",
  // crm_tools.py:350-363, form_tools.py:187-192, template_tools.py:174-179
  "Set up the CRM, forms and templates",
  // automation_tools.py:356-366
  "Add, change, copy and delete automations, and turn them on or off",
  "Answer automation cards",
  "Disconnect an app, or connect it again",
];

/**
 * The events a Zap can start from: app/zapier/events.py:783-851, named
 * as the Zapier app names them (integrations/zapier/triggers/hooks.js:39-365).
 */
export const ZAPIER_EVENTS = [
  "New student, parent or tutor",
  "Form filled out, or website inquiry",
  "Meeting booked, requested, rescheduled or canceled",
  "New inbound message",
  "New task, or task completed",
  "Person joins a CRM column",
  "Payment failed or received",
  "Payment method or tutor bank added",
  "Student archived",
];

/**
 * What a Zap can do: app/zapier/actions.py:545-570 (ACTIONS) and its
 * searches (703-876), named as integrations/zapier/creates/index.js and
 * searches/index.js name them.
 */
export const ZAPIER_ACTIONS = [
  "Send a message or a form",
  "Add or update a student, parent or tutor",
  "Book, change, reschedule or cancel a meeting",
  "Create or update a task",
  "Move someone to a CRM column",
  "Add a note, or ask a family for a card or bank",
  "Set up CRM fields, lists, boards and columns",
  "Find people, meetings and open times",
  "Get today's briefing or a report",
];
